import axios from 'axios';
import { appendParams } from '../utils/urlUtils.js';

const UXT_CONTENT_PREVIEW_PARAM = 'uxt-content-preview';
const getContentfulContent = async ({ errorHandler, url, previewMode, }) => {
    const builtUrl = previewMode
        ? appendParams(url, { [UXT_CONTENT_PREVIEW_PARAM]: previewMode })
        : url;
    try {
        const response = await axios.request({
            url: builtUrl,
            headers: { Accept: 'application/json' },
        });
        return response.data.model;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            errorHandler?.captureException(error, `get contentful content for URL: ${builtUrl}. HTTP status: ${error.response?.status}`);
        }
        throw error;
    }
};

export { getContentfulContent };
//# sourceMappingURL=contentfulService.js.map
